import { render } from "./dynamic-yield.vue?vue&type=template&id=2966c476"
import script from "./dynamic-yield.vue?vue&type=script&lang=js"
export * from "./dynamic-yield.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__